import React, { useContext } from 'react';
import { GlobalSiteDataContext } from '../context';
import { MetroHero, Doctors, LocationsBanner, OurMetroStores } from '../components';
import { SEO } from '../components';

function MetroTemplate() {
    const siteData = useContext(GlobalSiteDataContext);
    return (
        <main id="metro-layout">
            <MetroHero currentMetro={siteData.currentMetro} />
            <OurMetroStores currentMetro={siteData.currentMetro} />
            <LocationsBanner siteData={siteData} />
            <span id="about-us"></span>
            <Doctors siteData={siteData} />
        </main>
    );
}

export const Head = ({ location, pageContext }) => {
    return (
        <SEO
            location={location}
            origin={pageContext.currentMetro.origin}
            title={`About Us | Milan Laser Hair Removal | ${pageContext.currentMetro.name}, ${pageContext.currentMetro.stateAbbrev} Locations`}
            description={`We provide state of the art laser hair removal treatments in a relaxing environment.`}
        />
    );
};

export default MetroTemplate;
